import {DiagnosticReportId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const DIAGNOSTIC_REPORT_HAS_PRIORITY_CHANGED = 'diagnosticReport.has_priority_changed';

export interface DiagnosticReportHasPriorityChangedEvent extends DomainEvent {
  name: string;
  diagnosticReportId: DiagnosticReportId;
  hasPriority: boolean;
}

export function createDiagnosticReportHasPriorityChangedEvent(
  diagnosticReportId: DiagnosticReportId,
  hasPriority: boolean
): DiagnosticReportHasPriorityChangedEvent {
  return Object.freeze({
    name: DIAGNOSTIC_REPORT_HAS_PRIORITY_CHANGED,
    diagnosticReportId,
    hasPriority
  });
}
